/**
 * DropdownMenuItems.jsx
 * Created by michaelbray on 6/4/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    commercialAccount: PropTypes.bool,
    signOut: PropTypes.func
};

export default class DropdownMenuItems extends React.Component {
    constructor(props) {
        super(props);

        this.goToMyAccount = this.goToMyAccount.bind(this);
        this.goToMyReservations = this.goToMyReservations.bind(this);
        this.goToMyFavorites = this.goToMyFavorites.bind(this);
        this.goToCommercial = this.goToCommercial.bind(this);
    }

    goToMyAccount(e) {
        e.preventDefault();
        window.location.assign('/account/profile');
    }

    goToMyReservations(e) {
        e.preventDefault();
        window.location.assign('/account/reservations');
    }

    goToMyFavorites(e) {
        e.preventDefault();
        window.location.assign('/account/favorites');
    }

    goToCommercial(e) {
        e.preventDefault();
        window.location.assign('/account/facilities');
    }

    render() {
        // Check if commercial user
        let commercialMenuItem = null;
        if (this.props.commercialAccount) {
            commercialMenuItem = (
                <li className="rec-select-option">
                    <button
                        className="rec-select-option-button"
                        title="Commerical"
                        aria-label="Commercial"
                        onClick={this.goToCommercial}
                        type="button">
                        <span className="rec-select-label">
                            Commercial
                        </span>
                    </button>
                </li>
            );
        }

        return (
            <ul>
                <li className="rec-select-option">
                    <button
                        className="rec-select-option-button"
                        title="My Account"
                        aria-label="My Account"
                        onClick={this.goToMyAccount}
                        type="button">
                            My Account
                    </button>
                </li>
                <li className="rec-select-option">
                    <button
                        className="rec-select-option-button"
                        title="My Reservations"
                        aria-label="My Reservations"
                        onClick={this.goToMyReservations}
                        type="button">
                            My Reservations
                    </button>
                </li>
                <li className="rec-select-option">
                    <button
                        className="rec-select-option-button"
                        title="My Favorites"
                        aria-label="My Favorites"
                        onClick={this.goToMyFavorites}
                        type="button">
                            My Favorites
                    </button>
                </li>
                {commercialMenuItem}
                <li className="rec-select-option">
                    <button
                        className="rec-close-dropdown-button"
                        onClick={this.props.signOut}
                        aria-label="Sign Out"
                        type="button">
                        Sign Out
                    </button>
                </li>
            </ul>
        );
    }
}

DropdownMenuItems.propTypes = propTypes;
